import React from 'react';
import BlogHeader from './BlogHeader';
import BlogFooter from './BlogFooter';
import BlogSidebar from './BlogSidebar';

export default function BlogLayout({ children, showSidebar = true, sidebarComponent = null, whiteBackground = false }) {
  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }

        .blog-layout-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background: ${whiteBackground ? '#ffffff' : 'var(--bg)'};
          overflow-x: hidden;
        }

        .blog-layout-main {
          flex: 1;
          max-width: var(--page-max);
          margin: 0 auto;
          width: 100%;
          padding: 40px var(--page-pad);
        }

        .blog-layout-grid {
          display: grid;
          grid-template-columns: 1fr 320px;
          gap: 40px;
          align-items: start;
          width: 100%;
        }

        .blog-layout-content {
          min-width: 0;
          width: 100%;
          overflow-x: hidden;
        }

        .blog-layout-sidebar {
          position: sticky;
          top: 80px;
          width: 100%;
          max-width: 320px;
        }

        .blog-layout-single {
          max-width: 900px;
          margin: 0 auto;
        }

        /* Ensure all cards fit within container */
        .card, .blog-post-card {
          max-width: 100%;
          box-sizing: border-box;
        }

        @media (max-width: 1024px) {
          .blog-layout-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }

          .blog-layout-sidebar {
            position: static;
            order: 2;
            max-width: 100%;
          }

          .blog-layout-content {
            order: 1;
          }
        }

        @media (max-width: 768px) {
          .blog-layout-main {
            padding: 24px 16px;
          }

          .blog-layout-grid {
            gap: 24px;
          }

          .blog-layout-content,
          .blog-layout-sidebar {
            width: 100% !important;
            max-width: 100% !important;
          }
        }
      `}</style>

      <div className="blog-layout-container">
        <BlogHeader />

        <main className="blog-layout-main">
          {showSidebar ? (
            <div className="blog-layout-grid">
              {/* Main Content */}
              <div className="blog-layout-content">
                {children}
              </div>

              {/* Sidebar */}
              <div className="blog-layout-sidebar">
                {sidebarComponent || <BlogSidebar />}
              </div>
            </div>
          ) : (
            <div className="blog-layout-single">
              {children}
            </div>
          )}
        </main>

        <BlogFooter />
      </div>
    </>
  );
}
